import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { SlideDTO } from 'src/app/model/slideDTO.model';
import { SettingsColors } from 'library-explorer';

@Component({
    selector: 'app-slide-text-audio',
    templateUrl: './slide-text-audio.component.html',
    styleUrls: ['./slide-text-audio.component.scss'],
    standalone: false
})
export class SlideTextAudioComponent implements OnInit {

  @Input() public slideData: SlideDTO;
  @Input() public requiredToCompleteAudio = false;
  @Input() public brandColors: SettingsColors;
  @Output() public audioEnded: EventEmitter<void> = new EventEmitter();
  
  constructor() { }

  ngOnInit() {
  }

}
